import API3 from '../api/apiUtils/api3';
import { ExtHubRequest } from '../authConfig';

const api3 = new API3({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/SecureFileUploader`,
  scopes: ExtHubRequest,
});

api3.createEntities([
  { name: 'GetAgencyIDByTeamAgencyDescription' },
  { name: 'GetFilesUploadedByAgencyAndStatus' },
  { name: 'GetFilesUploadedByProducer' },
  { name: 'GetAgentOffices' },
  { name: 'GetFilterOptions_DropDown' },
  { name: 'GetYesNo_DropDown' },
  { name: 'OutstandingPolicyList' },
  { name: 'OutstandingPolicyListFast' },
  { name: 'SuitabilityPolicyListFast' },
  { name: 'SaveUploadedFiles' },
  { name: 'DeleteCanceledFiles' },
  { name: 'DeleteFile' },
  { name: 'ProcessMultipleFiles' },
  { name: 'AgencyRecordLock' },
  { name: 'AgencyRecordLock' },
  { name: 'GetUploadHistoryById' },
  { name: 'AgencyManageFileSave' },
  { name: 'GetAgentLineOfBusiness' },
]);

//#region Endpoints
const GetAgencyIDByTeamAgencyDescription = (body) =>
  api3.endpoints.GetAgencyIDByTeamAgencyDescription.get(body);
const GetFilesUploadedByAgencyAndStatus = (body) =>
  api3.endpoints.GetFilesUploadedByAgencyAndStatus.post(body);
const GetFilesUploadedByProducer = (body) => api3.endpoints.GetFilesUploadedByProducer.post(body);
const GetAgentOffices = (body) => api3.endpoints.GetAgentOffices.post(body);
const GetFilterOptions_DropDown = () => api3.endpoints.GetFilterOptions_DropDown.get();
const GetYesNo_DropDown = () => api3.endpoints.GetYesNo_DropDown.get();
const OutstandingPolicyList = (body) => api3.endpoints.OutstandingPolicyList.post(body);
const OutstandingPolicyListFast = (body) => api3.endpoints.OutstandingPolicyListFast.post(body);
const SuitabilityPolicyListFast = (body) => api3.endpoints.SuitabilityPolicyListFast.post(body);
const ProcessMultipleFiles = (body) => api3.endpoints.ProcessMultipleFiles.post(body);
const GetUploadHistoryById = (id) => api3.endpoints.GetUploadHistoryById.getWithURI(id);
const GetAgentLineOfBusiness = (id) => api3.endpoints.GetAgentLineOfBusiness.getWithURI(id);
//#endregion

// #region File Operations
const SaveUploadedFiles = (data) => api3.endpoints.SaveUploadedFiles.postData(data);
const DeleteCanceledFiles = ({ guid }) =>
  api3.endpoints.DeleteCanceledFiles.deleteWithURI({ guid });
const DeleteFile = ({ fileName }) => api3.endpoints.DeleteFile.deleteWithURI({ fileName });
const AgencyRecordLock = (recordID, lockRecord) =>
  api3.endpoints.AgencyRecordLock.post({}, {}, [
    { queryParam: 'recordID', queryVal: recordID },
    { queryParam: 'lockRecord', queryVal: lockRecord },
  ]);
const AgencyManageFileSave = (body) => api3.endpoints.AgencyManageFileSave.post(body);
// #endregion

export {
  GetAgencyIDByTeamAgencyDescription,
  GetFilesUploadedByAgencyAndStatus,
  GetFilesUploadedByProducer,
  GetAgentOffices,
  GetFilterOptions_DropDown,
  GetYesNo_DropDown,
  OutstandingPolicyList,
  OutstandingPolicyListFast,
  SuitabilityPolicyListFast,
  SaveUploadedFiles,
  DeleteCanceledFiles,
  DeleteFile,
  ProcessMultipleFiles,
  AgencyRecordLock,
  GetUploadHistoryById,
  AgencyManageFileSave,
  GetAgentLineOfBusiness,
};
